/* Kilo — custom slide-out cart drawer.
   Opens on header cart-link click and after add-to-cart, instead of the
   /cart page. Renders line items from /cart.js, supports qty change / remove,
   and exposes window.KiloCartDrawer for the upsell component to open/refresh. */
(function () {
  var root, panel, itemsEl, emptyEl, footerEl, subtotalEl, upsellWrap;
  var moneyFormat = '${{amount}}';
  var busy = false;

  /* --- money formatting (standard Shopify helper, trimmed) --- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || moneyFormat;

    function defaultTo(num, def) { return num == null ? def : num; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function money(cents) { return formatMoney(cents, moneyFormat); }

  /* --- render --- */
  function lineItemHTML(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">'
      : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="kilo-drawer__item-variant">' + item.variant_title + '</span>'
      : '';
    return (
      '<div class="kilo-drawer__item" data-key="' + item.key + '">' +
        '<div class="kilo-drawer__item-media">' + img + '</div>' +
        '<div class="kilo-drawer__item-info">' +
          '<span class="kilo-drawer__item-title">' + item.product_title + '</span>' +
          variant +
          '<div class="kilo-drawer__item-bottom">' +
            '<span class="kilo-drawer__qty">' +
              '<button type="button" data-kilo-qty="-1" aria-label="Decrease">&minus;</button>' +
              '<span class="kilo-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="button" data-kilo-qty="1" aria-label="Increase">+</button>' +
            '</span>' +
            '<span class="kilo-drawer__item-price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="kilo-drawer__item-remove" data-kilo-remove>Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  function render(cart) {
    if (!itemsEl) return;
    updateHeaderCount(cart);

    if (!cart.items || cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      if (upsellWrap) upsellWrap.classList.add('is-hidden');
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;
    if (upsellWrap) upsellWrap.classList.remove('is-hidden');

    itemsEl.innerHTML = cart.items.map(lineItemHTML).join('');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('.kilo-header__cart-count').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* --- open / close --- */
  function open() {
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function refresh(cart) {
    if (cart) { render(cart); return Promise.resolve(cart); }
    return getCart().then(function (c) { render(c); return c; });
  }

  function openAndRefresh() {
    open();
    return refresh();
  }

  /* --- cart mutations --- */
  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* --- event wiring --- */
  function isCartTrigger(el) {
    return el.closest(
      '.kilo-header__cart-link, .kilo-header__mobile-utility-link, [data-kilo-cart-open]'
    );
  }

  function bind() {
    // Open on cart-link clicks (delegated).
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a');
      if (trigger && isCartTrigger(e.target)) {
        e.preventDefault();
        openAndRefresh();
      }
    });

    // Close interactions.
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kilo-drawer-close]') || e.target.hasAttribute('data-kilo-drawer-overlay')) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // Qty / remove inside the drawer.
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.kilo-drawer__item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      if (e.target.closest('[data-kilo-remove]')) {
        changeLine(key, 0);
        return;
      }
      var qtyBtn = e.target.closest('[data-kilo-qty]');
      if (qtyBtn) {
        var delta = parseInt(qtyBtn.getAttribute('data-kilo-qty'), 10);
        var current = parseInt(row.querySelector('.kilo-drawer__qty-value').textContent, 10) || 1;
        var next = Math.max(0, current + delta);
        changeLine(key, next);
      }
    });

    // Intercept the product add-to-cart form → AJAX add → open drawer.
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { return openAndRefresh(); })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          });
      },
      true
    );
  }

  function init() {
    root = document.querySelector('[data-kilo-drawer]');
    if (!root) return;
    panel = root.querySelector('.kilo-drawer__panel');
    itemsEl = root.querySelector('[data-kilo-drawer-items]');
    emptyEl = root.querySelector('[data-kilo-drawer-empty]');
    footerEl = root.querySelector('[data-kilo-drawer-footer]');
    subtotalEl = root.querySelector('[data-kilo-drawer-subtotal]');
    upsellWrap = root.querySelector('[data-kilo-drawer-upsell]');
    moneyFormat = root.getAttribute('data-money-format') || moneyFormat;

    window.KiloCartDrawer = { open: open, close: close, refresh: refresh, openAndRefresh: openAndRefresh };

    bind();
    // Prime contents so the first open is instant.
    getCart().then(render).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
